<template>
    <div class="flex items-center justify-center w-full">
        <div class="flex flex-col gap-4 w-full max-w-[500px]">
            <h1 class="text-2xl font-bold">
                Reset Password: {{ user.username }}
            </h1>
            <FormKit type="form" @submit="submit" :actions="false">
                <FormKit
                    type="password"
                    name="password"
                    label="Password"
                    v-model="newPassword"
                />
                <FormKit
                    type="password"
                    name="password_confirm"
                    validation="confirm"
                    label="Confirm Password"
                />
                <FormKit type="submit" label="Reset Password" />
            </FormKit>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { usePage, router } from "@inertiajs/vue3";
import { FormKit } from "@formkit/vue";

const user = computed(() => usePage().props.user);
const token = computed(() => usePage().props.token);
const newPassword = ref("");

const submit = () => {
    router.post(
        "/reset-password/" + token.value,
        {
            newPassword: newPassword.value,
        },
        {
            headers: {
                "X-CSRF-Token": usePage().props._csrfToken,
            },
        },
    );
};
</script>
